export const apiCreate = (): string => '/commercial/services/'
export const apiList = (id?: string): string =>
  !id ? '/commercial/services/' : `/commercial/services/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/services/update/${id}`
export const apiDelete = (id: string): string => `/commercial/services/${id}`
